// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --headerHeight: 4rem;
  --headerHeightMobile: calc(var(--headerHeight) * .8);
}

:root {
  --headerHeight: 3.5rem;
}

.header-logged-out {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 3.5rem;
  padding: calc(.5rem) 1rem;
  background-color: #fff;
  border-top: 1px solid #e5e6e6;
  border-bottom: 1px solid #e5e6e6;
}

@media (width > 640px) {

.header-logged-out {
    padding: calc(.5rem) calc(1.5rem)
}
  }

.header-logged-out-legacy {
  height: calc(2.8rem);
  background: #fff;
}

@media (width > 640px) {

.header-logged-out-legacy {
    height: 3.5rem
}
  }

.help-button {
  position: absolute;
  top: 0;
  right: 1rem;
  display: flex;
  align-items: center;
  height: calc(2.8rem);
}

@media (width > 640px) {

.help-button {
    height: 3.5rem
}
  }

.help-button button {
    padding: calc(.25rem);
    background: none;
    border: none;
    border-radius: 0.25rem;
  }

.help-button button:hover {
      background-color: rgb(0, 0, 0, 0.08);
    }

.help-button button:active {
      background-color: rgb(0, 0, 0, 0.1);
    }
`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
